var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.series.length > 0)?_c('div',[_c('apexchart',{ref:"chart",attrs:{"type":"bar","options":_vm.chartOptions,"height":_vm.chartHeight,"series":_vm.series}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }